import React from "react";
import classnames from "classnames";
import SvgInline from "../SvgInline";
import CrossIcon from "!svg-inline-loader!./images/cross.svg";
import CheckIcon from "!svg-inline-loader!./images/check.svg";
import { showStatus, teaserStatus } from "../../constants";

import formatNumber from "../../utils/formatNumber";

import IfPermission from "../../components/IfPermission";
import * as perm from "../../utils/perm";
import spaceint2 from "../../utils/spaceint2";

const emptyStat = {
  clicks: 0,
  shows: 0,
  ctr: 0,

  top_clicks: 0,
  top_shows: 0,
  top_ctr: 0,

  inf_clicks: 0,
  inf_shows: 0,
  inf_ctr: 0
};

const StatTable = ({ teaser, onShowTypeChange }) => {
  const teaserShowsInTop =
    teaser.type == showStatus.all || teaser.type == showStatus.top;
  const teaserShowsInInf =
    teaser.type == showStatus.all || teaser.type == showStatus.inf;

  const isShowInTop = teaser.campaign.show_in_top && teaserShowsInTop;
  const isShowInInf = teaser.campaign.show_in_inf && teaserShowsInInf;

  const canEnableShowInTop = teaser.campaign.show_in_top;
  const canEnableShowInInf = teaser.campaign.show_in_inf;

  const allShowsEnabled = isShowInTop && isShowInInf;

  //const topIcon = isShowInTop ? CrossIcon : CheckIcon;
  //const infIcon = isShowInInf ? CrossIcon : CheckIcon;

  let topIcon;
  let infIcon;
  let topIconActive = false;
  let infIconActive = false;

  if (isShowInTop) {
    topIcon = CrossIcon;
    topIconActive = allShowsEnabled;
  } else {
    topIcon = CheckIcon;
    topIconActive = canEnableShowInTop;
  }

  if (isShowInInf) {
    infIcon = CrossIcon;
    infIconActive = allShowsEnabled;
  } else {
    infIcon = CheckIcon;
    infIconActive = canEnableShowInInf;
  }

  const handleShowsInTopChange = () => {
    if (!topIconActive) {
      return;
    }

    const nextShowsInTop = isShowInTop ? false : true;

    console.log("change show in top to", nextShowsInTop);

    let realShowType;
    // были показы везде, выключили в топе
    if (teaser.type == showStatus.all && nextShowsInTop == false) {
      console.log("next type: inf");
      realShowType = showStatus.inf;
    }
    // были показы в информере а теперь еще и в топе
    else if (teaser.type == showStatus.inf && nextShowsInTop) {
      console.log("next type: all");
      realShowType = showStatus.all;
    }

    onShowTypeChange(realShowType);
  };
  const handleShowsInInfChange = () => {
    if (!infIconActive) {
      return;
    }

    const nextShowsInInf = isShowInInf ? false : true;

    console.log("change show in inf to", nextShowsInInf);

    let realShowType;
    // были показы везде, выключили в информере
    if (teaser.type == showStatus.all && nextShowsInInf == false) {
      console.log("next type: top");
      realShowType = showStatus.top;
    }
    // были показы в топе а теперь еще и в информере
    else if (teaser.type == showStatus.top && nextShowsInInf) {
      console.log("next type: all");
      realShowType = showStatus.all;
    }

    onShowTypeChange(realShowType);
  };

  const stat = teaser.stat || emptyStat;

  return (
    <table>
      <tbody>
        <IfPermission checker={perm.canViewFullMiniStat}>
          <tr>
            <td className="teaser__stat-name">Всего</td>
            <td>
              <i
                className={classnames("teaser__stat-status-icon", {
                  green: teaser.published == teaserStatus.active,
                  gray: teaser.published == teaserStatus.inactive,
                  red: teaser.published == teaserStatus.reject,
                  black: teaser.published == teaserStatus.delete,
                  yellow: teaser.published == teaserStatus.moderate
                })}
              />
            </td>
            <td className="teaser__stat-action" />
            <td className="teaser__stat-value">{spaceint2(stat.clicks)}</td>
            <td className="teaser__stat-value">{spaceint2(stat.shows)}</td>
            <td className="teaser__stat-value">{stat.ctr}</td>
          </tr>
          <tr className={isShowInTop ? "" : "gray"}>
            <td className="teaser__stat-name">Топ</td>
            <td>
              <i
                className={classnames("teaser__stat-status-icon", {
                  gray: !isShowInTop,
                  green: isShowInTop
                })}
              />
            </td>
            <td className="teaser__stat-action">
              <IfPermission checker={perm.canChangeArea}>
                <SvgInline
                  src={topIcon}
                  className={classnames("teaser__stat-action-button", {
                    "teaser__stat-action-button-active": topIconActive
                  })}
                  onClick={handleShowsInTopChange}
                />
              </IfPermission>
            </td>
            <td className="teaser__stat-value">{spaceint2(stat.top_clicks)}</td>
            <td className="teaser__stat-value">{spaceint2(stat.top_shows)}</td>
            <td className="teaser__stat-value">{stat.top_ctr}</td>
          </tr>
        </IfPermission>
        <tr className={isShowInInf ? "" : "gray"}>
          <td className="teaser__stat-name">Инф</td>
          <td>
            <i
              className={classnames("teaser__stat-status-icon", {
                gray: !isShowInInf,
                green: isShowInInf
              })}
            />
          </td>
          <td className="teaser__stat-action">
            <IfPermission checker={perm.canChangeArea}>
              <SvgInline
                src={infIcon}
                className={classnames("teaser__stat-action-button", {
                  "teaser__stat-action-button-active": infIconActive
                })}
                onClick={handleShowsInInfChange}
              />
            </IfPermission>
          </td>
          <td className="teaser__stat-value">{spaceint2(stat.inf_clicks)}</td>
          <td className="teaser__stat-value">{spaceint2(stat.inf_shows)}</td>
          <td className={classnames("teaser__stat-value")}>
            {stat.inf_ctr}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default StatTable;
